import React from 'react';
import PremiumRecipes from '../components/PremiumRecipes';
import Navbar from '../components/Navbar';

const Premiumpage = () => {
    return (
        <div>
            <Navbar></Navbar>
            <PremiumRecipes></PremiumRecipes>
        </div>
    );
}

export default Premiumpage;
